/** Fallback der Sentry-ErrorBoundary — bewusst ohne Tailwind/Abhängigkeiten, damit es immer rendert. */
export default function CrashFallback() {
  return (
    <div
      role="alert"
      style={{
        minHeight: '100svh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        textAlign: 'center',
        fontFamily: 'BDOGrotesk, system-ui, sans-serif',
      }}
    >
      <h1 style={{ fontSize: 24, fontWeight: 600, margin: '0 0 8px' }}>Etwas ist schiefgelaufen</h1>
      <p style={{ fontSize: 16, color: '#6f6f6f', margin: '0 0 24px', maxWidth: 360, lineHeight: 1.5 }}>
        Bitte lade die Seite neu. Wenn das Problem bleibt, scanne den QR-Code am Automaten erneut.
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          minHeight: 52,
          padding: '0 24px',
          borderRadius: 12,
          border: 0,
          background: '#000',
          color: '#fff',
          fontSize: 16,
          fontWeight: 700,
          fontFamily: 'inherit',
        }}
      >
        Seite neu laden
      </button>
    </div>
  )
}
